const mockEvents = [
    {
        id: 1,
        event_name: "Değişen Dünyada Gelişen Kariyerler",
        event_type: "Seminer",
        company_name: "Oyak Renault",
        date: "14.04.2022",
        time: "15.00 - 16.00",
        event_format: "Online",
        quota: "1/24",
        status: "active"
    },
    {
        id: 2,
        event_name: "Teknoloji Dünyasında Kariyer Fırsatları",
        event_type: "Workshop",
        company_name: "Türk Telekom",
        date: "20.04.2022",
        time: "10.00 - 12.00",
        event_format: "Online",
        quota: "5/30",
        status: "active"
    },
    {
        id: 3,
        event_name: "Finans Sektörüne Giriş",
        event_type: "Webinar",
        company_name: "Garanti BBVA",
        date: "28.04.2022",
        time: "14.00 - 15.30",
        event_format: "Online",
        quota: "0/50",
        status: "active"
    }
];

const getAll = async (config) => {
    const filter = config?.params?.filter ?? {};
    let rows = [...mockEvents];

    if (filter.event_name) {
        rows = rows.filter((row) => row.event_name.toLowerCase().includes(filter.event_name.toLowerCase()));
    }
    if (filter.company_name) {
        rows = rows.filter((row) => row.company_name.toLowerCase().includes(filter.company_name.toLowerCase()));
    }

    return Promise.resolve({
        data: {
            data: rows,
            pagination: {
                total: rows.length
            }
        }
    });
};

const join = async (_id) => {
    return Promise.resolve({ data: { success: true } });
};

const store = async (formData) => {
    const newEvent = {
        id: mockEvents.length + 1,
        event_name: formData.event_name,
        event_type: formData.event_type,
        company_name: '',
        date: formData.date,
        time: `${formData.start_time} - ${formData.end_time}`,
        event_format: formData.event_format,
        quota: `0/${formData.quota}`,
        status: 'active'
    };
    mockEvents.push(newEvent);
    return Promise.resolve({ data: { message: 'success' } });
};

const updateStatus = async (id, status) => {
    const row = mockEvents.find((item) => item.id === Number(id));
    if (row) row.status = status;
    return Promise.resolve({ data: { message: 'coop_status_updated_success' } });
};

const remove = async (id) => {
    const index = mockEvents.findIndex((item) => item.id === Number(id));
    if (index !== -1) mockEvents.splice(index, 1);
    return Promise.resolve({ data: { message: 'success' } });
};

export default {
    getAll,
    join,
    store,
    updateStatus,
    remove
};
